import React from "react";

export function ResumeBuilder() {
	return <div>Resume Builder page</div>;
}
